module.exports = __webpack_public_path__ + "static/media/x.d646575.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/x.mp4
// module id = vXgw
// module chunks = 15